import { render } from "./JoinUsPage.vue?vue&type=template&id=916637d2"
import script from "./JoinUsPage.vue?vue&type=script&lang=js"
export * from "./JoinUsPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/fluffypony/Projects/tai-g-damn/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__